import { withNamespaces } from "react-i18next";
import { Badge, Card, CardBody, CardHeader, Progress } from "reactstrap";
import { COMPLIANCE_MODULES_LABELS_MAP, COMPLIANCE_MODULES_STATUS_MAP } from "src/modules/data-protection/constants";
import { INTERNATIONAL_DATE_FORMAT } from "src/common/constants";
import DateUtils from "src/services/utils/DateUtils";

const ComplianceModules = ({ t, complianceQuery }) => {
    if (complianceQuery.isFetching) return null;

    const dateUtils = new DateUtils();

    const {
        modules,
        statistics
    } = complianceQuery.data?.data || {};

    const completed =
        statistics?.modules?.submitted || 0;

    const total =
        statistics?.modules?.total || 0;

    const percent =
        statistics?.modules?.percentComplete || 0;

    const pendingModules =
        statistics?.modules?.pendingSlugs || [];

    return (
        <Card className="mb-4">
            <CardHeader>
                <div className="d-flex justify-content-between align-items-center">
                    <div>
                        <h5 className="mb-0">
                            {t('Assessment Progress')}
                        </h5>
                    </div>

                    <Badge color="light" className="text-dark">
                        {t('{{submitted}} of {{total}} modules submitted', {
                            submitted: completed,
                            total: total
                        })}
                    </Badge>
                </div>
            </CardHeader>

            <CardBody>
                <div className="mb-4">
                    <div className="d-flex justify-content-between mb-2">
                        <span className="fw-medium">
                            {t('Completion Progress')}
                        </span>

                        <span className="text-muted">
                            {percent}%
                        </span>
                    </div>

                    <Progress
                        value={percent}
                        color={
                            percent === 100
                                ? "success"
                                : "primary"
                        }
                    />
                </div>

                {pendingModules.length > 0 && (
                    <div className="mb-4">
                        <div className="fw-semibold mb-2">
                            {t('Pending Assessments')}
                        </div>

                        <div className="d-flex flex-wrap gap-2">
                            {pendingModules.map(
                                slug => (
                                    <Badge
                                        key={slug}
                                        color="warning"
                                        pill
                                        className="bg-warning"
                                    >
                                        {
                                            t(COMPLIANCE_MODULES_LABELS_MAP[
                                                slug
                                            ]?.label)
                                        }
                                    </Badge>
                                )
                            )}
                        </div>
                    </div>
                )}

                <div>
                    <div className="fw-semibold mb-3">
                        {t('Assessment Modules')}
                    </div>

                    <div className="d-flex flex-column gap-3">
                        {modules.map(module => {
                            const status =
                                COMPLIANCE_MODULES_STATUS_MAP[
                                    module.status
                                ] ||
                                COMPLIANCE_MODULES_STATUS_MAP.draft;

                            return (
                                <div
                                    key={module.slug}
                                    className="border rounded p-3"
                                >
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            <div className="fw-medium">
                                                {
                                                    t(COMPLIANCE_MODULES_LABELS_MAP[
                                                        module
                                                            .slug
                                                    ]?.label)
                                                }
                                            </div>

                                            {module.submittedAt && (
                                                <small className="text-muted">
                                                    {t('Submitted on {{date}}', {
                                                        date: dateUtils.convertDateToDate(
                                                            module.submittedAt,
                                                            INTERNATIONAL_DATE_FORMAT
                                                        )
                                                    })}
                                                </small>
                                            )}
                                        </div>

                                        <Badge
                                            color={
                                                status.color
                                            }
                                            className={`bg-${status.color}`}
                                        >
                                            <i
                                                className={`${status.icon} me-1`}
                                            />
                                            {
                                                t(status.label)
                                            }
                                        </Badge>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </CardBody>
        </Card>
    )
}

export default withNamespaces()(
    ComplianceModules
);